/**
 * Módulo: Fund Carousel
 * Swiper com navegação por setas, sem autoplay.
 * Suporta múltiplas instâncias na mesma página.
 */

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function initFundCarousel() {
  document.querySelectorAll('.fund-carousel__swiper').forEach(el => {
    const wrapper = el.closest('.fund-carousel');
    if (!wrapper) return;

    // Destroy existing instance before re-init (SPA navigation safety)
    if (el.swiper) el.swiper.destroy(true, true);

    const prevEl = wrapper.querySelector('.fund-carousel__btn--prev');
    const nextEl = wrapper.querySelector('.fund-carousel__btn--next');

    if (!prevEl || !nextEl) {
      console.warn('[fund-carousel] Navigation buttons not found in', wrapper);
    }

    const slideCount = el.querySelectorAll('.swiper-slide').length;

    new Swiper(el, {
      modules: [Navigation],
      slidesPerView: 1,
      loop: slideCount > 1,
      navigation: {
        prevEl,
        nextEl,
      },
      a11y: {
        prevSlideMessage: 'Slide anterior',
        nextSlideMessage: 'Próximo slide',
      },
    });
  });
}
